__turbopack_context__.v({
  "city": "_9wuisG_city",
  "placeholder": "_9wuisG_placeholder",
  "postal-code": "_9wuisG_postal-code",
  "postal-code-city-row": "_9wuisG_postal-code-city-row",
  "street": "_9wuisG_street",
  "street-name-number-row": "_9wuisG_street-name-number-row",
  "street-number": "_9wuisG_street-number",
});
